module.exports = __webpack_public_path__ + "img/barcode_image.85620e0a.png";